module.exports = __webpack_public_path__ + "static/media/vip-trophy-3.8505fdbe.png";